import { Box, Link } from "@mui/material";
import Button from "components/common/Button";
import Feedback from "components/common/Feedback";
import Typography from "components/common/Typography";
import Validation from "components/common/Validation";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { onDownloadClick } from "utils/CommonFunctions";
import { uploadFileAsync } from "./Recommendations.slice";

function Index() {
  const dispatch = useAppDispatch();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const recommendationsFileUploadForm = useAppSelector(
    (state: any) => state.formDetails.recommendationsFileUpload?.status
  );

  const {
    setError,
    clearErrors,
    formState: { errors }
  } = useForm();

  const [selectedFile, setSelectedFile] = useState<any>();
  const [hasNoAccess, sethasNoAccess] = useState<boolean>(false);

  const onFileChange = (event: any) => {
    clearErrors();

    if (event.target.files[0].type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      setError("selectedfile", {
        type: "filetype",
        message: "Whoa! Invalid file type."
      });
      return;
    }

    setSelectedFile(event.target.files[0]);
  };

  const onFileUpload = (e: any) => {
    const formData = new FormData();
    formData.append("file", selectedFile);
    dispatch(uploadFileAsync(formData));
  };

  return !hasNoAccess ? (
    <>
      <Feedback form="recommendationsFileUpload" message="Your file has been uploaded. Well-Done!" />
      <Box mb={3}>
        <Link component="button" onClick={() => onDownloadClick("recommendations", "recommendation", sethasNoAccess)}>
          Download Previous File
        </Link>
      </Box>
      <Box>
        <input name="file" type="file" accept=".xlsx,.xls" onChange={onFileChange} />
      </Box>

      <Box mb={3}>
        {errors.selectedfile && (
          <Validation name="file" type={errors.selectedfile?.type} message={"" + errors.selectedfile?.message} />
        )}
      </Box>

      <Button
        variant="primary"
        label={"Upload File"}
        disabled={!!errors.selectedfile || !selectedFile}
        onClick={onFileUpload}
      ></Button>
    </>
  ) : (
    <Typography variant={"h3"} color={tokens.Text.Feedback.Warning}>
      Unauthorized Access
    </Typography>
  );
}

export default Index;
